import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

// Estilos baseados no arquivo de usuários
export const CadastrosContainer = styled.div`
  width: 100%;
`;

export const CadastrosContent = styled.div`
  border-radius: 8px;
  padding: 24px;
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const TableContainer = styled.div`
  margin-bottom: 20px;
  overflow-x: auto;
`;

export const ModalContent = styled.div`
  padding: 20px;

  p {
    margin-bottom: 15px;
  }
`;

export const ModalButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

export const ErrorMessage = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
`;

export const SuccessMessage = styled.div`
  background-color: #d4edda;
  color: #155724;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.textColor};
  text-align: right;
`;

export const Input = styled.input`
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const Select = styled.select`
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  background-color: ${({ theme }) => theme.white};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const TextArea = styled.textarea`
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const Button = styled.button`
  height: 40px;
  padding: 0 16px;
  background-color: ${({ theme }) => theme.primaryColor};
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.secondaryColorHover};
  }
`;

export const Checkbox = styled.div`
  display: flex;
  align-items: center;

  input {
    margin-right: 8px;
    width: 18px;
    height: 18px;
  }

  label, span {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const SubocorrenciasContainer = styled.div`
  margin-top: 16px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  padding: 16px;
  background-color: ${({ theme }) => theme.white};
`;

export const SubocorrenciaTitle = styled.h4`
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 16px;
  color: ${({ theme }) => theme.textColor};
  font-weight: 500;
`;

export const SubocorrenciaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 12px;
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SubocorrenciaInput = styled.input`
  flex: 1;
  height: 36px;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  min-width: 0;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 8px;
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryColor};
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

export const AddButton = styled.button`
  height: 36px;
  padding: 0 16px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #218838;
  }
`;

export const RemoveButton = styled.button`
  height: 36px;
  padding: 0 12px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #c82333;
  }

  @media (max-width: 768px) {
    align-self: flex-end;
  }
`;
